var e=typeof navigator<"u"&&String(navigator.userAgent)||"";export{e as default};
